'use client'
import React, { ReactNode, useEffect } from 'react'
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react'
import { HiOutlineArrowLeft } from "react-icons/hi2";
import { IoMdClose } from "react-icons/io";
interface ModalProps {
  modalOpen: boolean;
  setModalOpen?: (open: boolean) => void;
  closeOnOutsideClick: boolean;
  children: ReactNode;
  className?: string;
  handleBack?: () => void;
}
const Modal: React.FC<ModalProps> = (props) => {
  const { modalOpen, setModalOpen, children,
    closeOnOutsideClick, className = "", handleBack } = props

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setModalOpen?.(false)
      }
    }
    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [setModalOpen])

  return (
    <Dialog open={modalOpen}
      onClose={closeOnOutsideClick ? () => setModalOpen?.(false) : () => setModalOpen?.(true)}
      className="relative z-50">
      <DialogBackdrop className="fixed inset-0 bg-black/30" />
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <DialogPanel className={`relative rounded-2xl bg-white shadow-xl overflow-hidden ${className}`}>
          {/* Close button w-full max-w-6xl*/}
          {setModalOpen && <button
            onClick={() => setModalOpen?.(false)}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 cursor-pointer z-500"
          >
            <IoMdClose size={24} />
          </button>}

          {handleBack && <button
            className="absolute left-4 top-4 text-gray-400 hover:text-gray-600 cursor-pointer z-500"
            onClick={handleBack}
          >
            <HiOutlineArrowLeft size={24} />
          </button>}
          {children}
        </DialogPanel>
      </div>
    </Dialog>
  )
}
export default Modal